export default __webpack_public_path__ + "86f57cb7897144997f8e5ab311455293.png";